<template>
	<img :src="src" alt="Image" @error="onError" />
</template>

<script>
export default {
	name: 'AppImage',
	props: {
		src: {
			type: String,
			required: true,
		},
		image: {
			type: String,
			default: '/resources/images/gray_not_found.png',
		},
	},
	data: function() {
		return {}
	},
	methods: {
		onError(e) {
			e.target.src = this.image
			this.$emit('imageNotFound')
		},
	},
}
</script>

<style></style>
